import styled from "@emotion/styled";
import theme from "../../styles/theme";

export const PullQuoteBase = styled.div`
  text-align: center;
  padding: ${theme.spacing[8]};
  background-color: ${theme.colors.blues[5]};
  border-radius: ${theme.borderRadius};
`;

export const Quote = styled.div`
  font-size: ${theme.fontSizes[4]};
  line-height: ${theme.leading.normal};
  margin-bottom: ${theme.spacing[4]};
`;

export const Attribution = styled.div`
  font-size: ${theme.fontSizes[1]};
  line-height: ${theme.leading.snug};
  color: ${theme.colors.darkBlues[75]};

  ${theme.largerThan.sm} {
    font-size: ${theme.fontSizes[2]};
  }
`;
